import { FirestoreDataConverter, DocumentData, QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";

export const TICKET_KEYWORD_EVENT_PATH = "events/search/ticket_keywords";

export type TicketKeywordEventType = {
  id: string;
  influencerId: string;
  keyword: string;
  createTime: number;
  updateTime: number;
};
export const ticketKeywordEventConverter: FirestoreDataConverter<TicketKeywordEventType> = {
  toFirestore(event: TicketKeywordEventType): DocumentData {
    return {
      id: event.id,
      influencerId: event.influencerId,
      keyword: event.keyword,
      createTime: event.createTime,
      updateTime: event.updateTime,
    };
  },
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): TicketKeywordEventType {
    const data = snapshot.data(options);
    return {
      id: snapshot.id,
      influencerId: data.influencerId,
      keyword: data.keyword,
      createTime: data.createTime,
      updateTime: data.updateTime,
    };
  },
};
